import PropTypes from 'prop-types';
import React from 'react';
import { Avatar, List, Table, Typography } from 'antd';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import { LoadingIcon } from '../../../components/loading';

const compact = ({ managers, loading, t }) => (
  <List
    dataSource={managers}
    loading={{
      indicator: LoadingIcon,
      size: 'large',
      spinning: loading || false,
    }}
    bordered
    renderItem={(item) => (
      <List.Item key={item.id}>
        <List.Item.Meta
          avatar={
            (item.picture)
              ? (<Avatar src={item.picture} />)
              : (<Avatar src="https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png" />)
          }
          title={item.email}
          description={<>{t('since')} {moment(item.created_at).fromNow()}</>}
        />
      </List.Item>
    )}
  />
);

compact.propTypes = {
  loading: PropTypes.bool,
  managers: PropTypes.array,
  t: PropTypes.func,
};

const full = ({ revoke, t, managers, loading }) => {
  const columns = [
    {
      title: t('email'),
      dataIndex: 'email',
    },
    {
      title: t('since'),
      dataIndex: 'created_at',
      render: (created_at) => moment(created_at).fromNow(),
    },
    {
      title: '',
      width: 100,
      render: (record) => {
        if (revoke) {
          return <Typography.Text>{revoke(record)}</Typography.Text>;
        }
        return '';
      },
    },
  ];

  return (
    <Table
      dataSource={managers || []}
      columns={columns}
      pagination={false}
      loading={{
        indicator: LoadingIcon,
        size: 'large',
        spinning: loading || false,
      }}
      bordered={false}
      scroll={{ x: true }}
      rowKey={(row, index) => index}
    />
  );
};

full.propTypes = {
  loading: PropTypes.bool,
  managers: PropTypes.array,
  revoke: PropTypes.func,
  t: PropTypes.func,
};

const ManagerList = withTranslation()((props) => {
  if (props.compact === true) {
    return compact(props);
  }

  return full(props);
});

export default ManagerList;
